<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-06-25 15:09:42
 * @FilePath: \gcp-fe\src\app\shop\components\showUser.vue
 * @Description: 
-->
<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-06-25 15:05:09
 * @FilePath: \gcp-fe\src\app\shop\components\showUser.vue
 * @Description: 登录用户信息
-->
<template>
  <div class="show-user fl">
    <div class="user ccui-clearfix">
      <img :src="headLogo" class="user-head mr15" />
      <div>
        <template v-if="loginInfo.name">
          <div class="user-type-welcome">您好，{{ loginInfo.name }}</div>
          <!-- <el-link type="primary" @click="handleExit"
            >退出<i class="icon-ccui-next"></i
          ></el-link> -->
          <div class="user-type-welcome welcomeBox">欢迎来到中交招采网</div>
          <button class="btn3" @click="handleExit">退出登录</button>
        </template>
        <template v-else>
          <div
            class="user-type-welcome"
            style="padding: 6px 0 0px 10px; margin-bottom: 6px"
          >
            您好！
          </div>
          <div class="user-type-welcome welcomeBox" style="margin-bottom: 14px">
            欢迎来到中交招采网
          </div>
          <div class="btnBox">
            <button class="btn1" @click="handleLogin">登录</button>
            <button class="btn2" @click="handleRegister">注册</button>
          </div>
          <div class="btnBoxs">
            <span class="btn" @click="ZHMM(1)">供应商找回密码</span>
            <span class="tup"></span>
            <span class="btn" @click="ZHMM(2)">分包商找回密码</span>
          </div>
          <div class="btnBoxs1">
            <!-- <span class="btn" @click="ZHMM(3)"
              >管控名单及黑名单重新认定申请及申诉</span
            > -->
            <span class="btn" @click="ZHMM(3)">管控名单或黑名单申诉</span>
          </div>
        </template>
      </div>
    </div>
    <!-- <div class="userimg ccui-clearfix">
      <div class="announcements-box">
        <div class="announcements-title ccui-clearfix">
          <i class="icon-ccui-trumpet" style="float:left;margin-top:5px"></i>
          <span class="fl">通知公告</span>
          <el-link
            :underline="false"
            type="info"
            class="fr color-1"
            @click="handleViewAll()"
            >更多 ></el-link
          >
        </div>
        <ul class="announcements-ul">
          <template v-for="item in pageData">
            <li :key="item.id" class="ellipsis announcements-ul-li">
              <a @click="handleOp(item)" class="ellipsis" :title="item.title">
                【公告】{{ item.title }}</a
              >
            </li>
          </template>
        </ul>
      </div>
    </div> -->
  </div>
</template>

<script>
// import { queryPublishedNoticeList } from "@/app/shop/api/shopping";
import Cookies from "js-cookie";
import { addUrlPerFix } from "@/basa/utils";
import {
  OAuth,
  // queryLscpPortalList,
  getBusiTravelUrl,
  // queryPublishedNoticeList,
  qryNoticeInfoPageList
} from "@/app/shop/api/shopping";

// import moment from "moment";
import { COMM_TYPE_MAPPING } from "@/config/const/comm";
import { updateNoticeHits } from "../api/shopping";
export default {
  name: "showUser",
  props: {
    imgData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dividerList: [],
      baseUrl: addUrlPerFix(process.env.VUE_APP_BASE_URL),
      purchaseAgentId: "",
      supplyAgentId: "",
      imgOptionsA: [],
      imgOptionsB: [],
      pageData: []
    };
  },
  mounted() {},
  activated() {
    this.init();
  },
  deactivated() {
    this.dividerList = [];
  },
  methods: {
    ZHMM(type) {
      // 分包商找回密码
      if (type === 1) {
        // 供应商
        this.$router.push({
          path: "/findPassword"
        });
      } else if (type === 2) {
        // 分包商
        this.$router.push({
          path: "/subFindPassword"
        });
      } else if (type === 3) {
        // 管控名单或黑名单申诉
        this.$router.push({
          path: "/subAppeal"
        });
      }
    },
    init() {
      // // 查询中交商旅
      // queryLscpPortalList({
      //   columnType: 4,
      //   isShowPageLoading: true
      // }).then(res => {
      //   if (res.data.code === "0") {
      //     this.imgOptionsA = res.data.data;
      //     // this.imgOptionsB =
      //     //   res.data.data.qryPostersListRspListBO[1].publicityContentBOS;
      //   }
      // });
      // // 查询中交福利
      // queryLscpPortalList({
      //   columnType: 5,
      //   isShowPageLoading: true
      // }).then(res => {
      //   if (res.data.code === "0") {
      //     this.imgOptionsB = res.data.data;
      //     // this.imgOptionsB =
      //     //   res.data.data.qryPostersListRspListBO[1].publicityContentBOS;
      //   }
      // });
      // queryPublishedNoticeList({
      //   pageNo: 1,
      //   pageSize: 6,
      //   module: 1,
      //   pageState: 2,
      //   textType: 1,
      //   appId: 100123
      // }).then(res => {
      //   if (res.data.code === "0") {
      //     // this.pageData = res.data.data.rows.filter(item => {
      //     //   return item.textType == 1;
      //     // });
      //     this.pageData = res.data.data.rows;
      //   }
      // });
      // 查询通知公告信息
      this.getNoticeInfoPageList();
    },
    // 更多
    handleViewAll() {
      this.$router.push({
        path: "/noticeList"
      });
    },
    handleOp(row) {
      //通知公告  https://test01-sp.iccec.cn/announcementDetail?id=94
      // let routeUrl = this.$router.resolve({
      //   path: addUrlPerFix(process.env.VUE_APP_SP_URL) + "/announcementDetail",
      //   query: {
      //     id: row.noticeInfoId
      //   }
      // });
      // window.open(routeUrl, "_blank");
      // window.location.href = `${this.$addUrlPerFix(
      //   process.env.VUE_APP_SP_URL
      // )}/announcementDetail?id=${row.noticeInfoId}&isJRZL=1&searchType=首页`;
      updateNoticeHits({ noticeId: row.id });
      this.$router.push({
        path: "/noticeDetail",
        query: {
          id: row.id
        }
      });
    },
    handleHelp(index, targetUrl) {
      // 中交商旅
      if (index === 1) {
        if (
          Cookies.get("access_token") &&
          JSON.parse(localStorage.getItem("userInfo"))?.openId
        ) {
          getBusiTravelUrl({
            empOpenId: JSON.parse(localStorage.getItem("userInfo")).openId
          }).then(res => {
            if (res.data.code == "0") {
              if (res.data.data.body) {
                window.location.href = res.data.data.body;
              }
            } else if (res.data.code == "111") {
              window.location.href = targetUrl;
            }
          });
        } else {
          window.location.href = targetUrl;
        }
        // window.open("https://newtravel.iccec.cn/userVue", "_blank");
        // if (Cookies.get("access_token")) {
        //   this.supplyAgentId = JSON.parse(
        //     localStorage.getItem("agentIdList")
        //   ).supplyAgentId;
        //   let href = "";
        //   if (this.baseUrl.indexOf("dev01") != -1) {
        //     href = `https://dev01-smp.iccec.cn/contractManagement/materialContractDraft/item-list?a=${this.supplyAgentId}`;
        //   } else if (this.baseUrl.indexOf("test01") != -1) {
        //     href = `https://test01-smp.iccec.cn/contractManagement/materialContractDraft/item-list?a=${this.supplyAgentId}`;
        //   } else if (this.baseUrl.indexOf("uat01") != -1) {
        //     href = `https://uat01-smp.iccec.cn/contractManagement/materialContractDraft/item-list?a=${this.supplyAgentId}`;
        //   } else {
        //     href = `https://smp.iccec.cn/contractManagement/materialContractDraft/item-list?a=${this.supplyAgentId}`;
        //   }
        //   window.open(href, "_blank");
        // } else {
        //   window.location.href =
        //     this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
        //     "?redirectUrl=" +
        //     this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
        // }
      }
      // 中交福利
      if (index === 2) {
        // window.open("https://new-welfare-h5.iccec.cn/", "_blank");
        let oma_remote_url = targetUrl + "@corpid@10000";
        OAuth({
          isShowLoading: true,
          // oma_remote_url: "https://aimarket.iccec.cn/front/login@corpid@10000"
          oma_remote_url: oma_remote_url
        }).then(res => {
          if (res.data.code == 111) {
            // let tagerUrl = "https://new-welfare-h5.iccec.cn/";
            // if (window.location.host.indexOf("test01") != -1) {
            //   tagerUrl = "http://dev.welfare.h5.aihl.ren/";
            // }
            window.location.href = targetUrl;
            return;
          }
          if (res.data.data) {
            window.location.href = res.data.data;
          }
        });
        // .catch(res => {
        //   if (res.data.code == 111) {
        //     this.$message({
        //       showClose: true,
        //       message: "请先登录！",
        //       duration: 3000,
        //       type: "error",
        //       ccuiCustom: true
        //     });
        //   }
        // });
      }
    },
    //退出
    handleExit() {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href =
        this.$addUrlPerFix("mla.iccec.cn/apis/mla/users/signup/doLogout") +
        "?ACCESS_TOKEN=" +
        Cookies.get("access_token") +
        "&redirectUrl=" +
        encodeURIComponent(window.location.href);
    },
    //登录
    handleLogin() {
      window.location.href =
        this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
        "?redirectUrl=" +
        encodeURIComponent(this.$addUrlPerFix(process.env.VUE_APP_BASE_URL));
    },
    // 新用户注册
    handleRegister() {
      // 跳转注册页面
      window.location.href = `${this.$addUrlPerFix(
        process.env.VUE_APP_SRA_URL
      )}`;
    },
    async getNoticeInfoPageList() {
      const res = await qryNoticeInfoPageList({
        pageNum: 1,
        pageSize: 6,
        status: 2,
        type: COMM_TYPE_MAPPING.INDEX_NOTICES
      });
      this.pageData = res.data.data.rows;
    }
  },
  computed: {
    loginInfo() {
      return this.$store.getters.getLoginInfo;
    },
    headLogo() {
      if (this.loginInfo.iConLink) {
        return this.loginInfo.iConLink;
      } else {
        return require("@/basa/assets/images/logOn.png");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.clearfix-item {
  display: flex;
  background: #ffffff;
}

.show-user {
  width: 260px;
  height: 240px;

  .user {
    width: 260px;
    height: 240px;
    margin-bottom: 10px;
    background: #ffffff;

    .user-head {
      width: 52px;
      height: 52px;
      display: block;
      margin: auto;
      padding: 18px 103px 5px 103px;
    }

    .user-type-welcome {
      // height: 28px;
      // font-family: PingFang-SC-Medium;
      // font-size: 20px;
      // color: #4a4a4a;
      // letter-spacing: 0;
      // font-weight: 500;
      width: 117px;
      height: 18px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #4a4a4a;
      line-height: 18px;
      text-align: center;
      margin: auto;
      font-style: normal;
      margin-bottom: 12px;
    }

    .welcomeBox {
      width: 130px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #666666;
      padding: 6px 0 0px 0;
    }

    .btnBox {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .btnBoxs1 {
      width: 100%;
      display: flex;
      font-size: 13px;
      align-items: center;
      justify-content: center;
      padding: 0 10px;
      box-sizing: border-box;
      margin-top: 4px;
      position: relative;
      .tup {
        position: absolute;
        height: 13px;
        width: 0;
        left: 129px;
        top: 5px;
        border-right: 2px solid #999999;
      }
      .btn {
        cursor: pointer;
        color: #999999;
      }
      .btn:hover {
        color: #0089ef;
        text-decoration: underline;
      }
    }
    .btnBoxs {
      width: 100%;
      display: flex;
      font-size: 13px;
      align-items: center;
      justify-content: space-between;
      padding: 0 30px;
      box-sizing: border-box;
      margin-top: 10px;
      position: relative;
      .tup {
        position: absolute;
        height: 13px;
        width: 0;
        left: 129px;
        top: 5px;
        border-right: 2px solid #999999;
      }
      .btn {
        cursor: pointer;
        color: #999999;
      }
      .btn:hover {
        color: #0089ef;
        text-decoration: underline;
      }
    }

    .btn1 {
      cursor: pointer;
      // margin-left: 16px;
      margin-right: 16px;
      width: 70px;
      height: 32px;
      border-radius: 4px;
      background: #ffffff;
      color: #0089ef;
      border: 1px solid #0089ef;
      font-size: 13px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
    }

    .btn2 {
      cursor: pointer;
      width: 70px;
      height: 32px;
      background: #0089ef;
      border-radius: 4px;
      font-size: 13px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      border: 1px solid #0089ef;
      color: #ffffff;
    }

    .btn3 {
      width: 109px;
      height: 32px;
      border: 1px solid #0089ef;
      border-radius: 4px;
      margin-left: 78px;
      background: #ffffff;
      font-size: 13px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #0089ef;
    }

    .user-type-link {
      height: 18px;
      font-family: PingFangSC-Regular;
      font-size: 13px;
      color: #4a4a4a;
      letter-spacing: 0;
      font-weight: 400;
    }
  }

  .userimg {
    width: 260px;
    height: 200px;
    background: #ffffff;

    .userimg-item {
      margin: 10px;
    }
  }
}

.divider-header {
  padding: 10px 0 16px 0;
  font-size: 12px;
  line-height: 18px;

  .titleIcon {
    display: inline-block;

    .icon-ccui-bell-o {
      margin-right: 5px;
      color: #ff954e;
    }

    .icon-ccui-bell-o + span {
      color: #4a4a4a;
    }
  }

  .titleIcon + a {
    color: #9b9b9b;
  }
}

.dividerList {
  width: 240px;
  font-size: 13px;
  color: #4a4a4a;
  letter-spacing: 0;
  font-weight: 400;

  li {
    line-height: 18px;
    font-weight: 400;
    margin-bottom: 4px;
  }
}

.fl {
  float: left;
}

.icon-trumpet {
  width: 15.02px;
  height: 14px;
  padding-right: 7px;
}

.help-center-img {
  margin: 0 8px 10px;
}

/deep/.announcements-box {
  margin: 5px 10px 0;
  font-size: 13px;
  line-height: 22px;

  .announcements-title {
    margin-bottom: 7px;

    .fl {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #4a4a4a;
    }

    .fr {
      line-height: 18px;
      font-size: 13px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #999999;

      &:hover {
        color: #0089ef;
      }
    }
  }

  .announcements-ul {
    padding: 3px 0 18px;

    .announcements-ul-li {
      font-size: 13px;
      color: #4a4a4a;
      letter-spacing: 0;
      line-height: 18px;
      font-weight: 400;
      margin-bottom: 8px;
      font-family: PingFangSC, PingFang SC;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
